export const adminMenu = (permissions, admin, isRPMEnable, isVirtualCareEnable, disabled_RPM_VirtualCare, isCTIEnabled, isWaitingRoom, isSFTEnabled) => {
    const menuItems =
    [
        {
            name: "Organizations",
            URL: "/app/manage-organization",
            enabled: permissions?.includes('Manage Organization') || admin,
        },
        {
            name: "IDP",
            URL: "/app/idp",
            enabled: permissions?.includes('manage-identityProviders') || admin,
        },
        {
            name: "Identities",
            children: [
                {
                    name: "Patients",
                    URL: "/app/identities/patients",
                    enabled: permissions?.includes('patient-read') || permissions?.includes('patient-create') || admin
                },
                {
                    name: "Employees",
                    URL: "/app/identities/employees",
                    enabled: permissions?.includes('practitioner-read') || permissions?.includes('practitioner-create') || admin
                },
                {
                    name: "Admin",
                    URL: "/app/identities/super-admins",
                    enabled: admin
                },
                {
                    name: "API Accounts",
                    URL: "/app/identities/api-accounts",
                    enabled: admin
                },
                {
                    name: "Devices",
                    URL: "/app/identities/devices",
                    enabled: admin 
                },
            ],
            enabled: permissions?.includes('patient-read') || permissions?.includes('patient-create') || permissions?.includes('Manage Individuals') || admin || permissions?.includes('practitioner-read') || permissions?.includes('practitioner-create') || permissions?.includes('device-read') || permissions?.includes('device-create'),
        },
        {
            name: "Roles",
            URL: "/app/manage-roles",
            enabled: permissions?.includes('Manage Roles') || admin,
        },
        {
            name: "Programs",
            children: [
                {
                    name: "Create Program",
                    URL: "/app/create-program",
                    enabled: isRPMEnable ? permissions?.includes('Manage Program') || admin : false,
                },
                {
                    name: "Program List",
                    URL: "/app/manage-program",
                    enabled: isRPMEnable ? permissions?.includes('Manage Program') || admin : false,
                },
            ],
            enabled: isRPMEnable ? permissions?.includes('Manage Program') || admin : false,
        },
        {
            name: "Schedule Category",
            URL: "/app/manage-schedule-category",
            enabled: admin || (permissions?.includes('Manage Schedule Category') && isVirtualCareEnable),
        },
        {
            name: "Questionnaire",
            children: [
                {
                    name: "Question Categories",
                    URL: "/app/manage-category",
                    enabled: permissions?.includes('Manage Questionnaire') || admin,
                },
                {
                    name: "Questions",
                    URL: "/app/manage-questions",
                    enabled:permissions?.includes('Manage Questionnaire') || admin,
                },
                {
                    name: "Questionnaires",
                    URL: "/app/manage-questionnaire",
                    enabled:permissions?.includes('Manage Questionnaire') || admin,
                },
            ],
            enabled: permissions?.includes('Manage Questionnaire') || admin,
        },
        {
            name: "Surveys",
            children: [
                {
                    name: "Surveys",
                    URL: "/app/manage-surveys",
                    enabled: isVirtualCareEnable,
                },
                {
                    name: "Survey Results",
                    URL: "/app/manage-surveys-results",
                    enabled: isVirtualCareEnable && (admin || permissions?.includes('Satisfaction Survey Results')),
                }                
            ],
            enabled: isVirtualCareEnable,
        },
        {
            name: "Notifications",
            URL: "/app/manage-notifications",
            enabled: permissions?.includes('Manage Notifications') || admin,
        },
        {
            name: "HCN Authority",
            URL: "/app/list-hcn-authority",
            enabled: permissions?.includes('Manage Organization'),
        },
        {
            name: "Locations",
            URL: "/app/locations",
            enabled: permissions?.includes('Manage Locations') || admin,
        },
        {
            name: "Groups",
            URL: "/app/manage-groups",
            enabled: admin || (permissions?.includes('Manage Groups') && (isVirtualCareEnable || isRPMEnable))
        },
        {
            name: "Documents",
            URL: "/app/documents",
            enabled: isVirtualCareEnable && (permissions?.includes('Manage Documents') || admin),
        },
        {
            name: "Report Deliveries",
            URL: "/app/report-deliveries",
            enabled: permissions?.includes('Report Deliveries - Read') || admin,
        },
        {
            name: "SFT Audit",
            URL: "/app/manage-sft",
            enabled: isSFTEnabled && (permissions?.includes('Manage SFT') || admin),
        },
    ].filter(item => {
        if (item.children) {
            item.children = item.children.filter(child => child.enabled === true);
            return item.children.length > 0;
        }
        return item.enabled === true;
});

    return menuItems;
};

export const appsMenu = (permissions, isRPMEnable, is_VirtualCareEnabled, admin, practitioner) => {
    const menuItems =
    [
        // don't show to admin
        !admin && (
        {
            name: "Encounters",
            URL: "/app/encounter-search",
            enabled: true,
        }),
        {
            name: "Providers Schedule & Appointments",
            URL: "/app/providers-schedule-appointments",
            enabled: admin || (permissions?.includes('Manage Provider Schedule & Appointments') && is_VirtualCareEnabled),
        },
        {
            name: "Schedule Overview",
            URL: "/app/schedule-overview",
            enabled: admin || (permissions?.includes('Manage Provider Schedule & Appointments') && is_VirtualCareEnabled),
        },
        {
            name: "Appointments",
            URL: "/app/appointment",
            enabled: admin || practitioner || (permissions?.includes('Appointment') && is_VirtualCareEnabled),
        },
        {
            name: "Resource Hub",
            URL: "/app/resources-hub",
            enabled: permissions?.includes("Access Resource Hub"),
        },
        {
            name: "Threshold Group",
            URL: "/app/threshold-groups",
            enabled: isRPMEnable ? (permissions?.includes('Manage Threshold Groups') || permissions?.includes('View Threshold Groups')) : false,
        },
        // {
        //     name: "Waiting Room",
        //     URL: "/app/waiting-room",
        //     enabled: permissions?.includes('Waiting Room Patients') || permissions?.includes('Waiting Room Enrollment'),
        // },
    ].filter(item => {
        if (item.children) {
            item.children = item.children.filter(child => child.enabled === true);
            return item.children.length > 0;
        }
        return item.enabled === true;
    });

    return menuItems;
};
